export const SET_LANG = 'SET_LANG';
export const SET_SIMULATED_USER = 'SET_SIMULATED_USER';
export const SET_SIMULATED_DATA = 'SET_SIMULATED_DATA';
export const SET_SIMULATED_AGENT = 'SET_SIMULATED_AGENT';
export const RESET_STORE = 'RESET_STORE';
export const SET_TEST = 'SET_TEST';
export const SET_LOADING_SIMULATED_USER = 'SET_LOADING_SIMULATED_USER';
export const CLEAR_SIMULATED_USER = 'CLEAR_SIMULATED_DATA';

export const setLang = (lang) => ({
  type: SET_LANG,
  payload: lang,
});

export const setSimulatedUser = (userId) => ({
  type: SET_SIMULATED_USER,
  payload: userId,
});

export const setSimulatedData = (data) => ({
  type: SET_SIMULATED_DATA,
  payload: data,
});

export const clearSimulatedData = () => ({
  type: CLEAR_SIMULATED_USER,
});

export const setSimulatedAgent = (agent) => ({
  type: SET_SIMULATED_AGENT,
  payload: agent,
});

export const resetStore = () => ({
  type: RESET_STORE,
});

export const setTest = (test) => ({
  type: 'SET_TEST',
  payload: test
});

export const setLoadingSimulatedUser = (loading) => ({
  type: SET_LOADING_SIMULATED_USER,
  payload: loading,
});